import {
  IOperationItem,
  OperationStatus,
  OperationType,
} from "../api/interface"
import { icons } from "../assets/icons"
import { formatPhoneNumber } from "./formatters"

export const getOperationIcon = (operationItem: IOperationItem) => {
  switch (operationItem.type) {
    // case OperationType.AGENT_PAYMENT:
    //     return icons.phoneIcon
    // case OperationType.PROVIDER_PAYMENT:
    //     return icons.phoneIcon
    // case OperationType.REFILL_PAYMENT:
    //     return icons.phoneIcon
    // case OperationType.INCOME_TRANSFER:
    //     return icons.phoneIcon
    // case OperationType.OUTCOME_TRANSFER:
    //     return icons.phoneIcon
    // case OperationType.SBP_INCOME_TRANSFER:
    //     return icons.sbpIcon
    // case OperationType.SBP_OUTCOME_TRANSFER:
    //     return "Исходящий перевод"
    default:
      return icons.phoneIcon
  }
}

export const getOperationTitle = (operationItem: IOperationItem) => {
  switch (operationItem.type) {
    case OperationType.AGENT_PAYMENT:
      return "Входящий перевод"
    case OperationType.AGENT_PAYMENT_REFUND:
      return "Возврат входящего перевода"
    case OperationType.PROVIDER_PAYMENT:
      return "Оплата товаров и услуг"
    case OperationType.PROVIDER_PAYMENT_REFUND:
      return "Возврат оплаты товаров и услуг"
    case OperationType.REFILL_PAYMENT:
      return "Пополнение кошелька"
    case OperationType.REFILL_PAYMENT_REFUND:
      return "Возврат пополнения"
    case OperationType.INCOME_TRANSFER:
      return "Входящий перевод"
    case OperationType.INCOME_TRANSFER_REFUND:
      return "Возврат входящего перевода"
    case OperationType.OUTCOME_TRANSFER:
      return "Исходящий перевод"
    case OperationType.OUTCOME_TRANSFER_REFUND:
      return "Возврат перевода клиенту"
    case OperationType.BALANCE_ADJUSTMENT_PAYMENT:
      return "Корректировка баланса"
    case OperationType.SBP_INCOME_TRANSFER:
      return "Входящий перевод"
    case OperationType.SBP_OUTCOME_TRANSFER:
      return "Исходящий перевод"
    case OperationType.SBP_OUTCOME_PAYMENT:
      return "Оплата по СБП"
    case OperationType.SBP_PAYOUT:
      return "Зачисление по СБП"
    case OperationType.SBP_REFUND:
      return "Возврат оплаты по СБП"
    case OperationType.SERVICE_PAYMENT:
      return "Комиссия за обслуживание"
    case OperationType.SERVICE_PAYMENT_REFUND:
      return "Возврат комиссии за обслуживание"
    default:
      return ""
  }
}

export const getOperationMasterField = (operationItem: IOperationItem) => {
  switch (operationItem.type) {
    case OperationType.INCOME_TRANSFER:
      return formatPhoneNumber(operationItem.masterField)
    case OperationType.OUTCOME_TRANSFER:
      return formatPhoneNumber(operationItem.masterField)
    case OperationType.SBP_INCOME_TRANSFER:
      return formatPhoneNumber(operationItem.masterField)
    case OperationType.SBP_OUTCOME_TRANSFER:
      return formatPhoneNumber(operationItem.masterField)
    default:
      return operationItem.masterField
  }
}

export const getDirection = (type: OperationType) => {
  switch (type) {
    case OperationType.AGENT_PAYMENT:
      return "+"
    case OperationType.AGENT_PAYMENT_REFUND:
      return "-"
    case OperationType.PROVIDER_PAYMENT:
      return "-"
    case OperationType.PROVIDER_PAYMENT_REFUND:
      return "+"
    case OperationType.REFILL_PAYMENT:
      return "+"
    case OperationType.REFILL_PAYMENT_REFUND:
      return "-"
    case OperationType.INCOME_TRANSFER:
      return "+"
    case OperationType.INCOME_TRANSFER_REFUND:
      return "-"
    case OperationType.OUTCOME_TRANSFER:
      return "-"
    case OperationType.OUTCOME_TRANSFER_REFUND:
      return "+"
    case OperationType.SBP_INCOME_TRANSFER:
      return "+"
    case OperationType.SBP_OUTCOME_TRANSFER:
      return "-"
    case OperationType.SBP_OUTCOME_PAYMENT:
      return "-"
    case OperationType.SBP_PAYOUT:
      return "+"
    case OperationType.SBP_REFUND:
      return "+"
    case OperationType.SERVICE_PAYMENT:
      return "-"
    case OperationType.SERVICE_PAYMENT_REFUND:
      return "+"
    default:
      return ""
  }
}

export const getOperationDirection = (operationItem: IOperationItem) =>
  getDirection(operationItem.type)

export const OPERATIONS_STATUS_DETAILS = {
  [OperationStatus.CREATED]: {
    icon: "waitTransfer",
    color: "blue",
    title: "Обработка",
    message: "Перевод в обработке",
    isSuccesseful: false,
    isFinal: false,
  },
  [OperationStatus.CREATE_ERROR]: {
    icon: "errorTransfer",
    color: "red",
    title: "Ошибка",
    message: "Не выполнен",
    isSuccesseful: false,
    isFinal: true,
  },
  [OperationStatus.ACCEPTED]: {
    icon: "checkYellow",
    color: "black",
    title: "Успешно",
    message: "Перевод выполнен",
    isSuccesseful: true,
    isFinal: true,
  },
  [OperationStatus.ACCEPT_ERROR]: {
    icon: "errorTransfer",
    color: "red",
    title: "Ошибка",
    message: "Не выполнен",
    isSuccesseful: false,
    isFinal: true,
  },
  [OperationStatus.REJECTED]: {
    icon: "errorTransfer",
    color: "red",
    title: "Отклонен",
    message: "Перевод отклонен",
    isSuccesseful: false,
    isFinal: true,
  },
  [OperationStatus.CANCELED]: {
    icon: "errorTransfer",
    color: "red",
    title: "Отменен",
    message: "Перевод отменен",
    isSuccesseful: false,
    isFinal: true,
  },
} as const

export const SBP_OPERATIONS_STATUS_DETAILS = {
  [OperationStatus.CREATED]: {
    icon: "waitTransfer",
    color: "blue",
    title: "Обработка",
    message: "В обработке",
    isSuccesseful: false,
    isFinal: false,
  },
  [OperationStatus.ACCEPTED]: {
    icon: "checkYellow",
    color: "black",
    title: "Успешно",
    message: "Успешно",
    isSuccesseful: true,
    isFinal: true,
  },
  [OperationStatus.ACCEPT_ERROR]: {
    icon: "errorTransfer",
    color: "black",
    title: "Ошибка",
    message: "Отклонена",
    isSuccesseful: false,
    isFinal: true,
  },
  [OperationStatus.REJECTED]: {
    icon: "errorTransfer",
    color: "red",
    title: "Отклонен",
    message: "Отклонена",
    isSuccesseful: false,
    isFinal: true,
  },
} as const

export const getStatusDetails = (status: OperationStatus) =>
  OPERATIONS_STATUS_DETAILS[status]

export const getOperationStatusDetails = (operation: IOperationItem) => {
  if (operation.type === OperationType.SBP_OUTCOME_PAYMENT) {
    return SBP_OPERATIONS_STATUS_DETAILS[operation.status as keyof typeof SBP_OPERATIONS_STATUS_DETAILS]
  }
  return OPERATIONS_STATUS_DETAILS[operation.status]
}

export const OPERATION_DATE_FORMAT = "DD MMMM YYYY HH:MM"
